import React, { FC } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Wrapper } from "../styled";
import Divider from "@mui/material/Divider";

const DrugsAdmission: FC = () => {
  return (
    <Wrapper display="flex" gap={2} pt={1}>
      <Box display="flex" flexDirection="column" gap={1}>
        <TextField
          label="Дата заключения нарколога"
          type="date"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Дата заключения психиатра"
          type="date"
          InputLabelProps={{ shrink: true }}
        />
        <Divider />
        <TextField label="Номер запроса в мвд" />
        <TextField
          label="Дата запроса в мвд"
          type="date"
          InputLabelProps={{ shrink: true }}
        />
        <Divider />
        <TextField label="Номер заключения мвд о допуске" />
        <TextField
          label="Дата заключения мвд о допуске"
          type="date"
          InputLabelProps={{ shrink: true }}
        />
      </Box>
      <Box display="flex" flexDirection="column" gap={1}>
        <TextField label="Номер приказа ЛПУ о допуске" />
        <TextField
          label="Дата приказа ЛПУ о допуске"
          type="date"
          InputLabelProps={{ shrink: true }}
        />
        <Divider />
        <TextField label="Номер постановления об исключении" />
        <TextField
          label="Дата постановления об исключении"
          type="date"
          InputLabelProps={{ shrink: true }}
        />
      </Box>
    </Wrapper>
  );
};

export default DrugsAdmission;
